/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="dental_office " size=32 />
 */
const DentalOffice = () => (
  <>
    <path
      d="M26.8333 24.8833V7.99166C23.2651 7.28485 19.6374 6.92208 16 6.90833C12.3625 6.92208 8.73477 7.28485 5.16663 7.99166V25.0917H26.8333V24.8833Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.9984 6.49171L16.0016 6.4917C19.6657 6.50556 23.32 6.871 26.9143 7.58298C27.1094 7.62163 27.25 7.7928 27.25 7.99171V25.0917C27.25 25.3218 27.0635 25.5084 26.8333 25.5084H5.16667C4.93655 25.5084 4.75 25.3218 4.75 25.0917V7.99171C4.75 7.7928 4.89059 7.62163 5.0857 7.58298C8.68 6.871 12.3343 6.50556 15.9984 6.49171ZM5.58333 8.33499V24.675H26.4167V8.33499C22.9835 7.67651 19.4963 7.33836 16 7.32504C12.5037 7.33836 9.01654 7.67651 5.58333 8.33499Z"
      fill="#142E54"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M24.3333 15.5084H7.66663V14.675H24.3333V15.5084Z" fill="#142E54" />
    <path d="M19.9417 18.35H16V25.0916H19.9417V18.35Z" fill="#B9DEFA" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5834 18.35C15.5834 18.1199 15.7699 17.9333 16 17.9333H19.9417C20.1718 17.9333 20.3584 18.1199 20.3584 18.35V25.0917C20.3584 25.3218 20.1718 25.5084 19.9417 25.5084H16C15.7699 25.5084 15.5834 25.3218 15.5834 25.0917V18.35ZM16.4167 18.7667V24.675H19.525V18.7667H16.4167Z"
      fill="#142E54"
    />
    <path d="M16 18.35H12.0583V25.0916H16V18.35Z" fill="#B9DEFA" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6417 18.35C11.6417 18.1199 11.8283 17.9333 12.0584 17.9333H16.0001C16.2302 17.9333 16.4167 18.1199 16.4167 18.35V25.0917C16.4167 25.3218 16.2302 25.5084 16.0001 25.5084H12.0584C11.8283 25.5084 11.6417 25.3218 11.6417 25.0917V18.35ZM12.4751 18.7667V24.675H15.5834V18.7667H12.4751Z"
      fill="#142E54"
    />
    <path
      d="M17.5584 22.2417C17.7885 22.2417 17.9751 22.0551 17.9751 21.825C17.9751 21.5949 17.7885 21.4083 17.5584 21.4083C17.3283 21.4083 17.1417 21.5949 17.1417 21.825C17.1417 22.0551 17.3283 22.2417 17.5584 22.2417Z"
      fill="#002D55"
    />
    <path
      d="M2.66663 11.7583H7.66663V24.2583C7.66663 24.4793 7.57883 24.6913 7.42255 24.8476C7.26627 25.0038 7.05431 25.0916 6.83329 25.0916H3.49996C3.27895 25.0916 3.06698 25.0038 2.9107 24.8476C2.75442 24.6913 2.66663 24.4793 2.66663 24.2583V11.7583V11.7583Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.25 11.7583C2.25 11.5282 2.43655 11.3417 2.66667 11.3417H7.66667C7.89679 11.3417 8.08333 11.5282 8.08333 11.7583V24.2583C8.08333 24.5899 7.95164 24.9078 7.71722 25.1422C7.4828 25.3766 7.16485 25.5083 6.83333 25.5083H3.5C3.16848 25.5083 2.85054 25.3766 2.61612 25.1422C2.3817 24.9078 2.25 24.5899 2.25 24.2583V11.7583ZM3.08333 12.175V24.2583C3.08333 24.3688 3.12723 24.4748 3.20537 24.553C3.28351 24.6311 3.38949 24.675 3.5 24.675H6.83333C6.94384 24.675 7.04982 24.6311 7.12796 24.553C7.2061 24.4748 7.25 24.3688 7.25 24.2583V12.175H3.08333Z"
      fill="#142E54"
    />
    <path
      d="M24.3334 11.7583H29.3334V24.2583C29.3334 24.4793 29.2456 24.6913 29.0893 24.8476C28.933 25.0038 28.7211 25.0916 28.5 25.0916H25.1667C24.9457 25.0916 24.7337 25.0038 24.5775 24.8476C24.4212 24.6913 24.3334 24.4793 24.3334 24.2583V11.7583V11.7583Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.9166 11.7583C23.9166 11.5282 24.1032 11.3417 24.3333 11.3417H29.3333C29.5634 11.3417 29.75 11.5282 29.75 11.7583V24.2583C29.75 24.5899 29.6183 24.9078 29.3838 25.1422C29.1494 25.3766 28.8315 25.5083 28.5 25.5083H25.1666C24.8351 25.5083 24.5172 25.3766 24.2827 25.1422C24.0483 24.9078 23.9166 24.5899 23.9166 24.2583V11.7583ZM24.75 12.175V24.2583C24.75 24.3688 24.7939 24.4748 24.872 24.553C24.9501 24.6311 25.0561 24.675 25.1666 24.675H28.5C28.6105 24.675 28.7164 24.6311 28.7946 24.553C28.8727 24.4748 28.9166 24.3688 28.9166 24.2583V12.175H24.75Z"
      fill="#142E54"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.975 11.7583C22.975 11.5282 23.1615 11.3417 23.3916 11.3417H30.275C30.5051 11.3417 30.6916 11.5282 30.6916 11.7583C30.6916 11.9885 30.5051 12.175 30.275 12.175H23.3916C23.1615 12.175 22.975 11.9885 22.975 11.7583Z"
      fill="#142E54"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.30835 11.7583C1.30835 11.5282 1.4949 11.3417 1.72502 11.3417H8.60835C8.83847 11.3417 9.02502 11.5282 9.02502 11.7583C9.02502 11.9885 8.83847 12.175 8.60835 12.175H1.72502C1.4949 12.175 1.30835 11.9885 1.30835 11.7583Z"
      fill="#142E54"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.9982 6.49172L16.0018 6.4917C20.5848 6.51186 25.1493 7.07537 29.5996 8.17045C29.823 8.22543 29.9596 8.45115 29.9046 8.6746C29.8496 8.89806 29.6239 9.03463 29.4005 8.97964C25.0147 7.90045 20.5165 7.34505 16 7.32505C11.4835 7.34505 6.9853 7.90045 2.59957 8.97964C2.37612 9.03463 2.1504 8.89806 2.09542 8.6746C2.04043 8.45115 2.177 8.22543 2.40046 8.17045C6.85075 7.07537 11.4152 6.51186 15.9982 6.49172Z"
      fill="#142E54"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6417 10.9417C11.6417 10.7116 11.8283 10.525 12.0584 10.525H19.9417C20.1718 10.525 20.3584 10.7116 20.3584 10.9417C20.3584 11.1718 20.1718 11.3584 19.9417 11.3584H12.0584C11.8283 11.3584 11.6417 11.1718 11.6417 10.9417Z"
      fill="#B9DEFA"
    />
  </>
)

export default DentalOffice
